// extracted by mini-css-extract-plugin
export default {"DeleteProjectsDialog":"DeleteProjectsDialog_DeleteProjectsDialog__l5J1x"};